module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v(_vm._s(_vm.selectedCampaign ? _vm.selectedCampaign.name : 'Select campaign'))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("Create your posts")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Review")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 1
    }
  }, [_c('v-card', {
    staticClass: "mb-5",
    attrs: {
      "elevation": "0"
    }
  }, [(_vm.campaigns && _vm.campaigns.length > 0) ? _c('v-card-text', [_c('v-list', {
    attrs: {
      "rounded": ""
    }
  }, [_c('v-subheader', [_vm._v("AVAILABLE CAMPAIGNS")]), _vm._v(" "), _c('v-list-item-group', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.selectedCampaign),
      callback: function($$v) {
        _vm.selectedCampaign = $$v
      },
      expression: "selectedCampaign"
    }
  }, _vm._l((_vm.campaigns), function(item, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "value": item
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-5",
    attrs: {
      "label": "Campaign Name",
      "placeholder": "Enter a new campaign",
      "outlined": ""
    },
    model: {
      value: (_vm.selectedCampaign.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedCampaign, "name", $$v)
      },
      expression: "selectedCampaign.name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": !_vm.selectedCampaign.name,
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("Create Posts")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    attrs: {
      "step": 2
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [(_vm.selectedCampaign && _vm.selectedCampaign.deliverables) ? _c('p', {
    staticClass: "deliverables"
  }, [_vm._v("\n            Your deliverables for this campaign:              \n            "), _vm._v(" "), _c('post-deliverables', {
    attrs: {
      "deliverables": _vm.selectedCampaign.deliverables
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post, postIndex) {
    return _c('v-row', {
      key: postIndex
    }, [_c('v-col', [_c('v-card', {
      attrs: {
        "rounded": "",
        "elevation": "0",
        "outlined": ""
      }
    }, [_c('v-card-title', {
      staticClass: "pt-1 pb-1"
    }, [_c('v-row', {
      staticStyle: {
        "margin-top": "1px",
        "margin-bottom": "20px"
      }
    }, [_c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "align": "left",
        "justify": "center"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            staticClass: "ma-0",
            attrs: {
              "color": "#3F3FFF",
              "small": "",
              "text-color": "white"
            }
          }, on), [(_vm.getPostTypeMeta(post.type).imgIcon) ? _c('img', {
            staticClass: "mr-1",
            staticStyle: {
              "object-fit": "contain",
              "filter": "invert(1)"
            },
            attrs: {
              "src": _vm.getPostTypeMeta(post.type).imgIcon,
              "width": "15px",
              "height": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }) : _c('v-icon', {
            staticStyle: {
              "color": "#ffffff !important"
            },
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v(_vm._s(_vm.getPostTypeMeta(post.type).icon))]), _vm._v("\n                            " + _vm._s(post.typeName) + "\n                            "), _c('v-icon', {
            attrs: {
              "small": "",
              "right": ""
            }
          }, [_vm._v("mdi-chevron-down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item-group', _vm._l((_vm.postType), function(item, postTypeIndex) {
      return _c('v-list-item', {
        key: postTypeIndex,
        attrs: {
          "value": item.type
        },
        on: {
          "click": function($event) {
            return _vm.postTypeChanged(postIndex, item)
          }
        }
      }, [_c('v-list-item-icon', {
        staticClass: "mr-3"
      }, [(item.imgIcon) ? _c('img', {
        staticStyle: {
          "object-fit": "contain"
        },
        attrs: {
          "src": item.imgIcon,
          "width": "20px",
          "height": "20px",
          "alt": "",
          "aria-hidden": "true"
        }
      }) : _c('v-icon', {
        style: (("color: " + (item.iconColor) + " !important;")),
        attrs: {
          "size": "20"
        }
      }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.typeName))])], 1)
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "align": "right",
        "justify": "center"
      }
    }, [_c('v-btn', _vm._g({
      staticClass: "ma-0",
      attrs: {
        "small": "",
        "color": "red",
        "outlined": "",
        "pill": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deletePost(postIndex)
        }
      }
    }, _vm.on), [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-trash-can-outline")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0 ma-0"
    }, [_c('post-form', {
      attrs: {
        "post": post,
        "influencer": _vm.influencerProfile,
        "campaign": _vm.selectedCampaign
      },
      on: {
        "text-changed": function($event) {
          return _vm.textChanged($event, postIndex)
        },
        "media-changed": function($event) {
          return _vm.mediaChanged($event, postIndex)
        },
        "vdo-link-changed": function($event) {
          return _vm.vdoLinkChanged($event, postIndex)
        },
        "remark-changed": function($event) {
          return _vm.remarkChanged($event, postIndex)
        }
      }
    })], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('v-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-0",
          attrs: {
            "color": "secondary",
            "outlined": "",
            "pill": ""
          }
        }, on), [_vm._v("\n                          Add New Content\n                          "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-plus")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.postType), function(item, postTypeIndex2) {
    return _c('v-list-item', {
      key: postTypeIndex2,
      on: {
        "click": function($event) {
          return _vm.addPost(item)
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [(item.imgIcon) ? _c('img', {
      staticStyle: {
        "object-fit": "contain"
      },
      attrs: {
        "src": item.imgIcon,
        "width": "20px",
        "height": "20px",
        "alt": "",
        "aria-hidden": "true"
      }
    }) : _c('v-icon', {
      style: (("color: " + (item.iconColor) + " !important;")),
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.typeName))])], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n              Back\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Review")]), _vm._v(" "), _c('v-spacer')], 1)], 2)], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "pa-1",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "step": 3
    }
  }, [_c('v-card', {
    staticClass: "max-auto",
    attrs: {
      "elevation": "0",
      "flat": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, _vm._l((_vm.posts), function(post, postIndex) {
    return _c('v-col', {
      key: postIndex,
      attrs: {
        "cols": "12",
        "md": "3",
        "lg": "3",
        "sm": "12"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2)),
            attrs: {
              "max-width": "344"
            }
          }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
            staticClass: "subtitle-1 ma-0"
          }, [_vm._v("\n                        " + _vm._s(_vm.selectedCampaign.name) + "\n                      ")]), _vm._v(" "), _c('v-list-item-subtitle', {
            staticClass: "caption font-italic"
          }, [(_vm.currentUserFullName && _vm.showActivePlatform) ? _c('social-handle', {
            attrs: {
              "isInstagram": _vm.activePlatform === 'instagram',
              "isTikTok": _vm.activePlatform === 'tiktok',
              "isYoutube": _vm.activePlatform === 'youtube',
              "isXiaohongshu": _vm.activePlatform === 'xiaohongshu',
              "isLinkedIn": _vm.activePlatform === 'linkedin',
              "isTwitter": _vm.activePlatform === 'twitter',
              "instagramHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "tiktokHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "youtubeHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "xiaohongshuHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "linkedinHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "twitterHandle": _vm.showActivePlatform.handle.replace('@', ''),
              "xiaohongshuFullName": _vm.showActivePlatform.fullName
            }
          }) : _vm._e(), _vm._v(" "), (_vm.currentUserFullName && !_vm.showActivePlatform) ? _c('social-handle', {
            attrs: {
              "isInstagram": _vm.activePlatform === 'instagram' || !_vm.activePlatform || _vm.currentInf.reqIgHandle,
              "isTikTok": _vm.activePlatform === 'tiktok' || _vm.currentInf.reqTikTokHandle,
              "isYoutube": _vm.activePlatform === 'youtube' || _vm.currentInf.reqYoutubeHandle,
              "isXiaohongshu": _vm.activePlatform === 'xiaohongshu',
              "isLinkedIn": _vm.activePlatform === 'linkedin',
              "isTwitter": _vm.activePlatform === 'twitter',
              "instagramHandle": _vm.currentUser.igHandle || _vm.currentInf.reqIgHandle,
              "tiktokHandle": _vm.currentUser.tiktokHandle || _vm.currentInf.reqTikTokHandle,
              "youtubeHandle": _vm.currentUser.youtubeHandle || _vm.currentInf.reqYoutubeHandle,
              "xiaohongshuHandle": _vm.currentUser.xhsHandle,
              "linkedinHandle": _vm.currentUser.linkedinHandle || (_vm.currentInf.linkedin && _vm.currentInf.linkedin.linkedinHandle),
              "twitterHandle": _vm.currentUser.twitterHandle || (_vm.currentInf.twitter && _vm.currentInf.twitter.twitterHandle)
            }
          }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-menu', {
            attrs: {
              "bottom": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "icon": ""
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          })], 1)], 1), _vm._v(" "), _c('v-card-text', {
            staticStyle: {
              "padding": "0px"
            },
            on: {
              "click": function($event) {
                return _vm.showDetails(post)
              }
            }
          }, [(!post.media) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            }
          }) : _vm._e(), _vm._v(" "), (post.media && post.media.length) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": post.media[0].preview.thumbnail,
              "aspect-ratio": "1"
            }
          }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [(post.captionText) ? _c('div', {
            staticClass: "text-truncate"
          }, [_c('strong', [_vm._v(_vm._s(post.captionText))])]) : _vm._e(), _vm._v(" "), (post.type !== 'post' && post.type !== 'carousel' && post.vdoLink) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            staticStyle: {
              "margin-top": "5px !important"
            },
            attrs: {
              "outlined": "",
              "color": "indigo",
              "target": "_blank",
              "href": post.vdoLink,
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-link")]), _vm._v("\n                        Video Link\n                      ")], 1)], 1) : _vm._e(), _vm._v(" "), (post.type === 'story' && post.remark && _vm.currentUserRole !== 5) ? _c('div', {
            staticClass: "text-truncate",
            staticStyle: {
              "margin-top": "20px"
            }
          }, [_c('strong', [_vm._v("Remark:")]), _vm._v("\n                        " + _vm._s(post.remark) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-chip', _vm._g({
            staticStyle: {
              "margin-bottom": "5px",
              "margin-left": "10px"
            },
            attrs: {
              "color": "#3F3FFF",
              "small": "",
              "text-color": "white"
            }
          }, _vm.on), [(_vm.getPostTypeMeta(post.type).imgIcon) ? _c('img', {
            staticClass: "mr-1",
            staticStyle: {
              "object-fit": "contain",
              "filter": "invert(1)"
            },
            attrs: {
              "src": _vm.getPostTypeMeta(post.type).imgIcon,
              "width": "15px",
              "height": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }) : _c('v-icon', {
            staticStyle: {
              "color": "#ffffff !important"
            },
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v(_vm._s(_vm.getPostTypeMeta(post.type).icon))]), _vm._v("\n                      " + _vm._s(post.typeName) + "                            \n                    ")], 1)], 1)], 1)
        }
      }], null, true)
    })], 1)
  }), 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left-circle")]), _vm._v("\n              Back\n            ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.validateSubmitPosts
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "text": 'Please stand by',
      "dialog": _vm.isLoading
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    on: {
      "click:outside": _vm.modalClickOutSide
    },
    model: {
      value: (_vm.imageDialog),
      callback: function($$v) {
        _vm.imageDialog = $$v
      },
      expression: "imageDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.imageDialog = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('custom-media-v2', {
    attrs: {
      "media": _vm.campaignHelper.customPostMediaConfig(_vm.previewMedia, {
        overlay: _vm.isCutOff,
        creatorView: true,
        postView: true
      })
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.previewMedia.preview) ? _c('a', {
    attrs: {
      "href": _vm.previewMedia.preview.src,
      "download": "",
      "target": "_blank"
    }
  }, [_c('v-btn', [_c('v-icon', {
    attrs: {
      "float-left": ""
    }
  }, [_vm._v("save_alt")]), _vm._v("Download")], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1000px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.postDetail),
      callback: function($$v) {
        _vm.postDetail = $$v
      },
      expression: "postDetail"
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card draft-post-detail-card"
  }, [_c('v-toolbar', {
    staticClass: "ims-modal-header",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedCampaign.name) + " Campaign\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.postDetail = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "ims-modal-body draft-post-detail-body",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-row', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-col', {
    staticClass: "pa-0 pt-2",
    attrs: {
      "xs": "1",
      "md": "1",
      "lg": "1"
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "xs": "6"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.currentUserFullName) + "\n                "), (_vm.currentUserFullName && _vm.showActivePlatform) ? _c('social-handle', {
    attrs: {
      "isInstagram": _vm.activePlatform === 'instagram',
      "isTikTok": _vm.activePlatform === 'tiktok',
      "isYoutube": _vm.activePlatform === 'youtube',
      "isLinkedIn": _vm.activePlatform === 'linkedin',
      "isTwitter": _vm.activePlatform === 'twitter',
      "instagramHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "tiktokHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "youtubeHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "linkedinHandle": _vm.showActivePlatform.handle.replace('@', ''),
      "twitterHandle": _vm.showActivePlatform.handle.replace('@', '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentUserFullName && !_vm.showActivePlatform) ? _c('social-handle', {
    attrs: {
      "isInstagram": _vm.activePlatform === 'instagram' || !_vm.activePlatform,
      "isTikTok": _vm.activePlatform === 'tiktok',
      "isYoutube": _vm.activePlatform === 'youtube',
      "isLinkedIn": _vm.activePlatform === 'linkedin',
      "isTwitter": _vm.activePlatform === 'twitter',
      "instagramHandle": _vm.currentUser.igHandle,
      "tiktokHandle": _vm.currentUser.tiktokHandle,
      "youtubeHandle": _vm.currentUser.youtubeHandle,
      "linkedinHandle": _vm.currentUser.linkedinHandle || (_vm.currentInf.linkedin && _vm.currentInf.linkedin.linkedinHandle),
      "twitterHandle": _vm.currentUser.twitterHandle || (_vm.currentInf.twitter && _vm.currentInf.twitter.twitterHandle)
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "xs": "6"
    }
  }, [(_vm.postData) ? _c('v-chip', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [(_vm.getPostTypeMeta(_vm.postData.type).imgIcon) ? _c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "object-fit": "contain",
      "filter": "invert(1)"
    },
    attrs: {
      "src": _vm.getPostTypeMeta(_vm.postData.type).imgIcon,
      "width": "15px",
      "height": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('v-icon', {
    staticStyle: {
      "color": "#ffffff !important"
    },
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v(_vm._s(_vm.getPostTypeMeta(_vm.postData.type).icon))]), _vm._v("\n              " + _vm._s(_vm.postData.typeName) + "\n            ")], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "align": "left",
      "justify": "left"
    }
  }, _vm._l((_vm.postData.media), function(media, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "4",
        "lg": "4",
        "sm": "3"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [(media.preview.thumbnail) ? _c('v-card', {
            staticClass: "max-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            },
            on: {
              "click": function($event) {
                return _vm.viewMedia(media)
              }
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": media.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1) : _c('v-card', {
            staticClass: "max-auto",
            attrs: {
              "flat": ""
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": media.preview.thumbnail,
              "aspect-ratio": "1"
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), (!media.preview.thumbnail) ? _c('btn-download', {
      attrs: {
        "url": media.preview.src
      }
    }) : _vm._e()], 1)
  }), 1), _vm._v(" "), (_vm.postData.captionText) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "draft-post-detail-copy"
  }, [_c('strong', [_vm._v("Caption")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.postData.captionText) + "\n            ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type === 'story' || _vm.postData.type === 'video' || _vm.postData.type === 'reel' || _vm.postData.type === 'tiktok') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "color": "indigo",
      "target": "_blank",
      "href": _vm.postData.vdoLink
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-link")]), _vm._v("\n                Video Link\n            ")], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.postData.type === 'story' && _vm.currentUserRole !== _vm.influencerRole) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "draft-post-detail-copy"
  }, [_c('strong', [_vm._v("Remark")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.postData.remark) + "\n            ")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions draft-post-detail-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.postDetail = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('influencer-terms-modal', {
    attrs: {
      "dialog": _vm.showAgreementModal
    },
    on: {
      "termsAggrement": _vm.submitPosts
    }
  }), _vm._v(" "), _c('post-media-preview-modal', {
    attrs: {
      "selectedCampaign": _vm.selectedCampaign,
      "postData": _vm.mediaPreviewData,
      "value": _vm.mediaPreviewDialog
    },
    on: {
      "confirmed": _vm.termsAgreed
    },
    model: {
      value: (_vm.mediaPreviewDialog),
      callback: function($$v) {
        _vm.mediaPreviewDialog = $$v
      },
      expression: "mediaPreviewDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48b52855"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/CreateDraftPostV2.vue
// module id = 2106
// module chunks = 0